/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClassLinkIntegrationAuthService } from '../services/integrations/classlink-integration-auth.service';
import { CleverIntegrationAuthService } from '../services/integrations/clever-integration-auth.service';
import { AuthService } from '../services/auth.service';
import { FirebaseProvider } from '../enums/firebaseProvider';

@Injectable({
  providedIn: 'root'
})
export class V3IntegrationGuard implements CanActivate {
  constructor(
    private router: Router,
    private classLinkIntService: ClassLinkIntegrationAuthService,
    private cleverIntService: CleverIntegrationAuthService,
    private authService: AuthService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const params = (new URL(window.location.href)).searchParams;
    const tk = route.queryParams?.token ||  params.get("token");
    const provider = route.queryParams?.provider || params.get("provider") || "";
    if(tk){
      const pToken = route.queryParams?.ptoken ||  params.get("ptoken");
      sessionStorage.removeItem('current');
      sessionStorage.setItem("authCustomTk", "true");
      sessionStorage.setItem("authCustomTkPass", "true");
      if(pToken){
        sessionStorage.setItem("pToken", pToken);
      }
      return this.authService.authWithCustomTk(tk, provider as FirebaseProvider);

    } else {
      const code = route.queryParams?.code || params.get("code");

      // Manejo de integración ClassLink
      if (code && provider === "") {
        return this.handleClassLinkIntegration(code);
      }
      
      // Manejo de integración Clever
      if (code && provider === "clever") {
        return this.handleCleverIntegration(code);
      }

 

      // Manejo de consentimiento de administrador de Microsoft
      const adminConsent = this.getAdminConsent();
      if (adminConsent) {
        const codeMicrosoft = route.queryParams?.admin_consent || params.get("admin_consent");
        if (codeMicrosoft) {
          return this.router.navigate([adminConsent?.pathName]);
        }
      }

      // Si no hay ninguna integración para procesar, permite la navegación
      return true;
    }

  }

  private handleClassLinkIntegration(code: string): Promise<boolean | UrlTree> {
    const loginRoute = this.authService.getRedirectLoginRoute();
    return this.classLinkIntService.getClasslinkInfo(code).then((value: boolean) => {
      if (value) {
        return this.router.navigate([window.location.pathname]);
      } else {
        return this.router.navigate([loginRoute]);
      }
    });
  }

  private handleCleverIntegration(code: string): Promise<boolean | UrlTree> {
    const redirect = `${environment.adminPortalURL}/cloudapps?provider=clever`;
     const loginRoute = this.authService.getRedirectLoginRoute();
    return this.cleverIntService.getCleverLinkInfo(code, redirect).then((value: boolean) => {
      if (value) {
        const path = sessionStorage.getItem('redirectUriClever');
        return this.router.navigate([path]);
      } else {
        return this.router.navigate([loginRoute]);
      }
    });
  }

  private getAdminConsent(): any {
    try {
      const adminConsentStr = sessionStorage.getItem('adminConsent');
      return adminConsentStr ? JSON.parse(adminConsentStr) : null;
    } catch (e) {
      console.error('Error parsing adminConsent', e);
      return null;
    }
  }
}